import * as angular from "angular";
import {IController} from "angular";
import {RuleFilterModel} from "../../models/rule-filter.model";
import {RuleActionModel} from "../../models/rule-action.model";
import {RuleControllerStage} from "../../models/rule-controller-stage.model";
import {RuleControllerStageConditionOperation} from "../../models/rule-controller-stage-condition-operation.model";
import {RuleStageCondition} from "../../models/rule-stage-condition.model";
import {RuleConditionStage} from "../../models/rule-condition-stage.model";
import {RuleEngineService} from "../../services/rule-engine.service";

export class RuleControllerComponent implements IController {

  controller: RuleControllerStage;
  controllerIndex: number;
  generalFilters: RuleConditionStage;
  filterOptions: RuleFilterModel[];
  controllerActionOptions: RuleActionModel[];
  metaData: any[];
  entitySubtypes: string[];
  isHideFilters: boolean;
  onRemoveController: Function;

  public accountIds: string[] = [];
  public subtypeFilterOptions: RuleFilterModel[];
  public subtypeActionOptions: RuleActionModel[];


  constructor(private ruleEngineService: RuleEngineService) {
  }


  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.controller) {
      if (!!this.controller?.entityType) {
        this._getSubtypeEntityFilters(this.controller.entityType);
        this._getSubtypeEntityActions(this.controller.entityType);
      }
    }
  }

  onAddCondition(controllerCondition: RuleControllerStageConditionOperation) {
    const filter: RuleStageCondition = {
      fieldName: undefined,
      operator: undefined,
      type: undefined,
      value: undefined,
      values: undefined
    }
    controllerCondition.conditions.push(filter)
  }

  onAddAction() {
    const action = {
      actionType: undefined,
      dataList: []
    };
    this.controller.actions.push(action);
  }

  onChangeConditions(condition, index) {

    const conditionsCopy = angular.copy(this.controller.conditionOperation.conditions);
    conditionsCopy[index] = condition;
    this.controller.conditionOperation.conditions = conditionsCopy;
    //
    // const accountIdsCondition = this.controller.conditionOperation.conditions.find((c) => c.fieldName === 'accountId');
    //
    // if (!!accountIdsCondition && accountIdsCondition.value) {
    //   this.accountIds
    // }
  }

  onRemoveCondition(controllerCondition: RuleControllerStageConditionOperation, conditionIndex: number) {
    controllerCondition.conditions.splice(conditionIndex, 1);
  }

  onRemoveControllerAction(index: number) {
    this.controller.actions.splice(index, 1);
  }

  onChangeSubtype(subtype: string) {
    if (this.controller.entityType === subtype) {
      return;
    }

    this.subtypeFilterOptions = undefined;
    this.subtypeActionOptions = undefined;
    this.controller.conditionOperation.conditions = [];
    this.controller.entityType = subtype;
    if (!!this.controller.entityType) {
      this._getSubtypeEntityFilters(this.controller.entityType);
      this._getSubtypeEntityActions(this.controller.entityType);
    }

  }

  private _getSubtypeEntityFilters(subtype) {
    this.ruleEngineService.getEntityFilters(subtype)
      .then((res: any) => {
        if (res?.length) {
          this.subtypeFilterOptions = res[0].fields;
        }
      })
  }

  private _getSubtypeEntityActions(subtype) {
    this.ruleEngineService.getEntityActions(subtype)
      .then((res: any[]) => {
        if (res?.length) {
          this.subtypeActionOptions = res[0].actions;
        }
      })
  }

}


angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleController', {
    bindings: {
      controller: '<',
      controllerIndex: '<',
      generalFilters: '<',
      filterOptions: '<',
      controllerActionOptions: '<',
      metaData: '<',
      entitySubtypes: '<',
      isHideFilters: '<?',
      onRemoveController: '&'
    },
    template: require('./rule-controller.html').default,
    controller: RuleControllerComponent
  });

